import Carousel from "nuka-carousel";

import { useI18n } from "utils/with-i18n.utils";

import { Card } from "./Card";

export const Numbers = () => {
  const i18n = useI18n();

  return (
    <section className="flex flex-col gap-5 items-center mx-auto w-full max-w-[90rem] md:gap-12 lg:pb-14">
      <h2 className="px-5 text-[30px] font-normal leading-8 text-center lg:px-0 lg:text-[50px] lg:text-left">
        {i18n.t("environment.numbers.title", { html: true }, { html: true })}
      </h2>
      <div className="hidden overflow-x-scroll w-full lg:block xl:overflow-auto">
        <div className="flex gap-2.5 justify-center px-9 pb-3 mx-auto w-max lg:gap-[36px]">
          <Card
            value={"environment.card1.value"}
            base={"environment.card1.text"}
            hover={"environment.card1.hover"}
          />
          <Card
            value={"environment.card2.value"}
            base={"environment.card2.text"}
            hover={"environment.card2.hover"}
          />
          <Card
            value={"environment.card3.value"}
            base={"environment.card3.text"}
            hover={"environment.card3.hover"}
          />
        </div>
      </div>
      <Carousel
        defaultControlsConfig={{
          nextButtonClassName: "hidden",
          prevButtonClassName: "hidden",
          pagingDotsContainerClassName: "gap-2 !hidden",
        }}
        className={"pb-8 !w-screen lg:hidden"}
      >
        <Card
          value={"environment.card1.value"}
          base={"environment.card1.text"}
          hover={"environment.card1.hover"}
        />
        <Card
          value={"environment.card2.value"}
          base={"environment.card2.text"}
          hover={"environment.card2.hover"}
        />
        <Card
          value={"environment.card3.value"}
          base={"environment.card3.text"}
          hover={"environment.card3.hover"}
        />
      </Carousel>
    </section>
  );
};
